import * as React from 'react'
import {firstResponseApiError} from '@frontrow/console/src/entities/models/api-error'

type UseModalFormReturn = {
  isOpen: boolean
  open: () => void
  close: () => void
  isLoading: boolean
  error: string | null
  handleAsyncAction: (fn: () => Promise<void>) => Promise<void>
}

export function useModalForm(): UseModalFormReturn {
  const [isOpen, setIsOpen] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const open = () => setIsOpen(true)

  const close = React.useCallback(() => {
    setIsOpen(false)
    setIsLoading(false)
    setError(null)
  }, [])

  const handleAsyncAction = React.useCallback(async (fn: () => Promise<void>): Promise<void> => {
    setIsLoading(true)
    setError(null)
    try {
      await fn()
    } catch (err: unknown) {
      const apiError = firstResponseApiError(err)
      setError(apiError.message)
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {isOpen, open, close, isLoading, error, handleAsyncAction}
}
